import { CollaboratorsSelect } from "@/features/request/create/shared/components/CollaboratorsSelect.tsx";
import { PreferredDesignersSelect } from "@/features/request/create/shared/components/PreferredDesignersSelect.tsx";
import { useCreateWebsiteImplementationRequestFormContext } from "@/features/request/create/website-implementation/components/useCreateWebsiteImplementationRequestForm.tsx";
import { useUser } from "@/hooks/useUser";

import { ComplexitySelect } from "./ComplexitySelect";

export function TechnicalDetailsSection() {
  const { data: user } = useUser();
  const methods = useCreateWebsiteImplementationRequestFormContext();

  const showComplexityField = [
    "customer-success",
    "super-admin",
    "team-leader",
  ].includes(user?.user.roleName || "");

  return (
    <>
      <div className="rounded-xl bg-bg-secondary p-3xl">
        <div className="flex flex-col gap-y-lg lg:grid lg:grid-cols-12 lg:gap-x-3xl">
          <span className="col-span-12 text-lg font-semibold text-text-primary">
            Technical Details
          </span>

          <PreferredDesignersSelect
            className={showComplexityField ? "col-span-6" : "col-span-12"}
            methods={methods}
          />
          {showComplexityField && <ComplexitySelect />}
        </div>
      </div>
      <div className="w-1/2 rounded-xl bg-bg-secondary p-3xl">
        <CollaboratorsSelect brandFieldName="brandId" methods={methods} />
      </div>
    </>
  );
}
